import {
  BoldSmallBodyText,
  Button,
  FlexRow,
  Grid,
  NavigationItem,
  SmallBodyText,
  TextField,
} from '../../../../../../ui-toolkit/components';
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrashCan, faX } from '@fortawesome/pro-regular-svg-icons';
import { ICreateHoaResponse, IHoaForm } from '../../../../../../types/order/hoa/IHoaDetailsTypes';
import { useFormikContext } from 'formik';
import GrayLine from '../../../../../shared/GrayLine';
import styled from 'styled-components';
import { DeleteHoaModalContainer } from './DeleteHoaModalContainer';

const StyledTextField = styled(TextField)`
  width: 100%;
`;

export interface IHoaRowProps {
  index: number;
  hoa: ICreateHoaResponse;
  onDelete: (values: IHoaForm, index: number) => void;
  onSave: (values: IHoaForm, index: number) => void;
  onRemoveNewHoa: (index: number) => void;
}

export const HoaRow: React.FC<IHoaRowProps> = ({ index, hoa, onSave, onDelete, onRemoveNewHoa }) => {
  const [editMode, setEditMode] = useState(hoa.id === undefined); //if its a new hoa we want to start in editmode
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const onClose = () => setEditMode(false);
  const values: IHoaForm = useFormikContext().values as IHoaForm;

  const onCancelClick = () => {
    onClose();
    if (hoa.id === undefined) {
      onRemoveNewHoa(index);
    }
  };

  const onSaveClick = () => {
    onSave(values, index);
    onClose();
  };

  const onDeleteClick = () => {
    onDelete(values, index);
  };

  return (
    <>
      {editMode ? (
        <>
          <FlexRow justifyContent={'space-between'}>
            <StyledTextField name={`hoas.${index}.name`} label={'Name of HOA'} placeholder={'Name'} />
            {hoa.id && (
              <NavigationItem onClick={() => setShowDeleteModal(true)} text={`Delete HOA`}>
                <FontAwesomeIcon icon={faTrashCan} />
              </NavigationItem>
            )}
            <NavigationItem onClick={onCancelClick} text={`Close`}>
              <FontAwesomeIcon icon={faX} />
            </NavigationItem>
          </FlexRow>
          <TextField
            name={`hoas.${index}.mgmtCoName`}
            label={'Management Company'}
            placeholder={'Name of Management Company'}
          />
          <TextField
            name={`hoas.${index}.primaryContactName`}
            label={'Primary Contact Name'}
            placeholder={'Full Name'}
          />
          <TextField name={`hoas.${index}.primaryContactEmail`} label={'Primary Contact Email'} placeholder={'Email'} />
          <TextField
            name={`hoas.${index}.primaryContactPhone`}
            label={'Primary Contact Phone'}
            placeholder={'(###) ###-####'}
          />
          <Grid columnCount={2}>
            <Button intent={'secondary'} type={'reset'} onClick={onCancelClick}>
              Cancel
            </Button>
            <Button intent={'primary'} onClick={onSaveClick}>
              Save
            </Button>
          </Grid>
        </>
      ) : (
        <>
          <FlexRow justifyContent={'space-between'}>
            {hoa.name && <BoldSmallBodyText>{hoa.name}</BoldSmallBodyText>}
            <NavigationItem onClick={() => setEditMode(true)} text={`Edit HOA`}>
              <FontAwesomeIcon icon={faEdit} />
            </NavigationItem>
          </FlexRow>
          {hoa.mgmtCoName && <SmallBodyText>{hoa.mgmtCoName} </SmallBodyText>}
          {hoa.primaryContactName && <SmallBodyText>{hoa.primaryContactName} </SmallBodyText>}
          {hoa.primaryContactEmail && <SmallBodyText>{hoa.primaryContactEmail}</SmallBodyText>}
          {hoa.primaryContactPhone && <SmallBodyText>{hoa.primaryContactPhone}</SmallBodyText>}
        </>
      )}
      {showDeleteModal && (
        <DeleteHoaModalContainer onClose={() => setShowDeleteModal(false)} onDelete={onDeleteClick} />
      )}
      <GrayLine />
    </>
  );
};
